import { render, staticRenderFns } from "./PresetDeleteModal.vue?vue&type=template&id=4975da40&"
import script from "./PresetDeleteModal.vue?vue&type=script&lang=ts&"
export * from "./PresetDeleteModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports